<template>
  <div class="reservation-services">
    <template v-for="service in services" :key="service.internal_name">
      <SeatingService
        v-if="service.internal_name === seatServiceInternalName && seatReservationEnabled"
        :service="service"
      />

      <ServiceBasic v-else :service="service" />
    </template>

    <ReservationBoxControls
      back-button-text="Späť na cestujúcich"
      continue-button-text="Pokračovať"
      @return="onReturn"
      @continue="onContinue"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import ServiceBasic from '../components/ServiceBasic.vue';
import ReservationBoxControls from '../components/ReservationBoxControls.vue';
import { pushRoute, Route } from '../router';
import { useReservation } from '../modules/useReservation';
import { useLocalTravellers } from '../modules/useLocalTravellers';
import SeatingService from '../components/SeatingService/SeatingService.vue';
import { useSeatReservation } from '../modules/useSeatReservation';
import { tracking } from '../modules/analytics/analytics';
import { useReservationTracking } from '../modules/useReservationTracking';

const { services } = window.RESERVATION_STORE;
const { trackPageView } = tracking();
const { trackTripEvent } = useReservationTracking();
const { setTravellersData } = useReservation();
const { localTravellersRef } = useLocalTravellers();
const { seatServiceInternalName } = useSeatReservation();

const seatReservationEnabled =
  window.RESERVATION_STORE.tripBaseInfo.tripDate.enable_seat_reservations;

const onReturn = () => {
  pushRoute(Route.TravellersData);
};

const onContinue = async () => {
  await setTravellersData(localTravellersRef.value);
  trackTripEvent({ event: 'reservation_add_services_data', value: 0 });
  pushRoute(Route.InvoiceData);
};

onMounted(() => {
  trackPageView({
    screen: 'RESERVATION_SERVICES_DATA',
  });
});
</script>
